<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-extra-menities-cart"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white" :class="{'box-shadow-nav':scrollPosition >40}">
                  <div class="container px-4 w-100 py-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant().code+'/concierge/extra-amenities'">
                            <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1" width="15">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.concierge.order-cart.extra-amenities')}}</p>
                        </div>
                      </div>
                      <!-- <div class="col-3 text-right">
                        <div class="mt-1">
                          <img src="../../../../assets/img/hotel/avatar-img.jpg" width="30" height="30" class="rounded-100 object-fit d-inline-block">
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="height-50px"></div>
    <template v-if="getConciergeOrder().cart.length > 0">  
      <div class="container px-4 mt-3 box-shadow-primary rounded-10">
        <div class="pt-3 pb-2">
          <div class="">
            <div class="">
              <p class="mb-3 body-3-3 text-16 font-bold">{{$t('hotel.concierge.your-order')}}</p>
              <template v-for="product_cart in getConciergeOrder().cart">
                <menuCart :data="product_cart" />
              </template>
              <router-link :to="'/'+getMerchant().code+'/concierge/extra-amenities'">
                <p class="mb-2 pb-1 body-2-2 font-semibold text-orange underline">+ {{$t('hotel.action.add-more')}}</p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="container px-4 py-3 box-shadow-primary rounded-10">
        <p class="mb-3 body-3-3 text-16 font-bold">{{$t('hotel.concierge.add-note')}}</p>
        <textarea v-model="note" class="form-control px-2 body-2 rounded-6 text-14 mb-2" rows="3" :placeholder="$t('hotel.concierge.note-placeholder.extra-amenities')"></textarea>
      </div>
      <cartPromoCode type="extra-amenities"></cartPromoCode>
      <div class="container px-4 py-3 box-shadow-primary rounded-10">
        <p class="mb-3 pt-4 body-3-3 text-16 font-bold">{{$t('hotel.concierge.price-detail')}}</p>
        <div class="box-shadow-primary p-3 border rounded-6 bg-light">
          <div class="row mb-2 pb-1">
            <div class="col-6">
              <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.sub-total')}}</p>
            </div>
            <div class="col-6 text-right">
              <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(getConciergeOrderSubTotal())}}</p>
            </div>
          </div>
          <div class="row mb-2 pb-1">
            <div class="col-6">
              <p class="mb-0 body-2-2 font-semibold text-green">{{$t('hotel.concierge.discount')}}</p>
            </div>
            <div class="col-6 text-right">
              <p class="mb-0 body-2-2 font-semibold text-green">- {{formatCurrency(getConciergeOrderTotalPromo())}}</p>
            </div>
          </div>
          <div class="row mb-2 pb-1">
            <div class="col-6">
              <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.tax-service')}}</p>
            </div>
            <div class="col-6 text-right">
              <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(getConciergeOrderTotalTaxServices())}}</p>
            </div>
          </div>
          <div class="border-top">
            <div class="row pt-2">
              <div class="col-6">
                <p class="mb-0 body-1-2 font-bold">{{$t('hotel.concierge.total')}}</p>
              </div>
              <div class="col-6 text-right">
                <p class="mb-0 body-1-2 font-bold">{{formatCurrency(total_price)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container px-4 pt-4 mb-2 mt-2">
         <button @click="submitInquiry" :disabled="push_loader" type="button" class="button-secondary w-100" :class="{'button-disabled': push_loader}">
          <pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
          <template v-else>
            {{$t('hotel.action.order-now')}}
          </template>
        </button>
      </div>
    </template>
    <template v-else>
      <div class="container px-5 text-center mt-5 pt-3">
        <img src="../../../../assets/img/icon/404.png" width="150" class="mt-2">
        <p class="mb-1 mt-3 body-2-2 font-bold text-20">{{$t('hotel.concierge.no-order')}}</p>
        <p class="mb-3 body-2-2 font-semibold">{{$t('hotel.concierge.no-order-desc.extra-amenities')}}</p>
        <router-link :to="'/'+getMerchant().code+'/concierge/extra-amenities'">
          <button class="button-secondary text-12 px-4">{{$t('hotel.action.order-now')}}</button>
        </router-link>
      </div>
    </template>
    <bottom-navbar></bottom-navbar>

    <warning-box 
      v-if="error_chat.show" 
      title="Action Message"
      :body="`Your order was successfully made but failed to register a chat account. You will be redirected to a success page in ${error_chat.timer} seconds`" />
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {formatCurrency} from '@/utils/index.js'
  import Flickity from 'vue-flickity';
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import menuCart from '@/components/hotel/concierge/general/menuCart'
  import cartPromoCode from '@/components/hotel/concierge/general/cartPromoCode'
  import {post} from '@/services/index.js';
  import WarningBox from '@/components/general/WarningBox'

  export default{
    components: {
      Flickity,
      BottomNavbar,
      menuCart,
      cartPromoCode,
      WarningBox
    },
    metaInfo(){
      return {
        title: 'Extra amenities order',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        scrollPosition: null,
        push_loader: false,
        note: '',
        error: '',
        error_chat: {
          show: false,
          timer: 0
        }
      }
    },
    computed:{
      total_price(){
        return this.getConciergeOrderSubTotal()+this.getConciergeOrderTotalTaxServices()-this.getConciergeOrderTotalPromo()
      },
      show_error_chat(){
        return this.error_chat.show
      }
    },
    watch:{
      show_error_chat(){
        if (this.error_chat.show) {
          let looping = setInterval(() => {
            if (this.error_chat.timer > 0) {
              this.error_chat.timer--
            }else if(this.error_chat.timer == 0){
              this.error_chat.show = false
              clearInterval(looping)
              this.resetConciergeOrder()
              this.$router.push('/'+this.getMerchant().code+'/concierge/extra-amenities/success?total='+res.data.total_payment)
            }
          },1000) 
        }
      }
    },
    methods: {
      ...mapGetters([
        'getMerchant',
        'getConciergeOrder',
        'getConciergeOrderTotal',
        'getConciergeOrderTotalTaxServices',
        'getConciergeOrderTotalPromo',
        'getConciergeOrderSubTotal',
        'getConciergeAuth',
        'getMetaTitleTemplate']),
      ...mapMutations(['resetConciergeOrder']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      submitInquiry(){
        if(!this.push_loader){
          this.push_loader = true
          let params = {
            merchant_id: this.getMerchant().id,
            products: [],
            notes: this.note,
            pms_detail_id: this.getConciergeAuth().detail_id,
            folio_no: this.getConciergeAuth().folio,
            promo_code: this.getConciergeOrder().promo_code,
            region: 'Indonesia',
            device: 'web'
          }
          for(let cart of this.getConciergeOrder().cart){
            if(cart.product.is_variant){
              for(let variant of cart.variant){
                let product = {
                  id: variant.data.product_ga_pos_id,
                  qty: variant.qty,
                  notes: variant.notes
                }
                params.products.push(product)
              }
            }else{
              let product = {
                id: cart.product.data.product_ga_pos_id,
                qty: cart.qty,
                notes: cart.notes
              }
              params.products.push(product)
            }
          }

          post("CONCIERGE","extra-amenities/tx-inquiry",params,"concierge_pin").then(response=>{
            let res = response.data
            if(res.success){
              this.resetConciergeOrder()
              this.$router.push('/'+this.getMerchant().code+'/concierge/extra-amenities/success?total='+res.data.total_payment)
            }else{
              this.error = res.message
              this.push_loader = false
            }
          })
        }
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-extra-menities-cart').scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/extraamenities/ExtraAmenitiesCart.vue